import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { rootRoute } from '../../../config';
import info from '../assets/info.png';
import time_elapse_icon from '../../../assets/time_elapse_icon.png';
import Button from '../../common/Button'
import FcModuleStyle from '../styles/fc.module.css';

const SimProgress = ({ popupState, actions }) => {
  const navigate = useNavigate();
  const [playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation, isShowPlaceOrder] = actions;
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error, isRequestLoading, fcPopup, setFcPopup] = popupState;
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [alertActive, setAlertActive] = useState(false);
  const [srMessage, setSrMessage] = useState("");
  const intervalDuration = 10; // 1 second in milliseconds
  const totalTime = 100; // Total time in seconds
  const isLeapYear = (year) => {
    return ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) ? 366 : 365;
  }
  //simObj?.laststate?.deadLineMonths + simObj?.laststate?.currentRampValue
  const progressbar = { "valuemin": 0, "valuemax": 24, "valuenow": function () { return (Math.round(((this.valuemax - simObj?.currentstate?.monthsleft) / this.valuemax) * 100)) } }
  const showSummary = () => {
    setIsLoader(true);
    navigate(rootRoute + "/fc/summary");
  }
  const getShortMonth = (month) => {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]
    return months[month - 1];
  }
  useEffect(() => { ((toggleSimulation) && simObj.status != 'COMPLETED' && error == null && currentTime == totalTime) && resumeSimulation(); }, [currentTime])
  useEffect(() => { !isRequestLoading && setCurrentTime(0); }, [isRequestLoading])
  useEffect(() => {
    let intervalId;
    if (isPlaying && currentTime < totalTime) {
      intervalId = setInterval(() => {
        setCurrentTime((prevTime) => prevTime + 1);
      }, intervalDuration);
    } else {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isPlaying, currentTime, totalTime]);

  useEffect(() => { (toggleSimulation) ? setIsPlaying(true) : setIsPlaying(false); }, [toggleSimulation]);
  // useEffect(() => {
  //   if (document.querySelector(`.${FcModuleStyle.simProg}`) != null && window.innerWidth > 991) {
  //     let top = 0;
  //     if (document.querySelector(`.${FcModuleStyle['sim-progress-activity']} .${FcModuleStyle.posuccess}`) != null) {
  //       // top = document.querySelector(`.${FcModuleStyle._progress}`).clientHeight + document.querySelector(`.${FcModuleStyle.posuccess}`).clientHeight+12;
  //       top = 100;
  //       document.querySelector(`.${FcModuleStyle.ui}.${FcModuleStyle.pointing}.${FcModuleStyle.label}.${FcModuleStyle.simProg}`).style.top = top + "%";
  //     }
  //     else {
  //       top = document.querySelector(`.${FcModuleStyle._progress}`).clientHeight + document.querySelector(`.${FcModuleStyle._progress}`).offsetTop;
  //       document.querySelector(`.${FcModuleStyle.ui}.${FcModuleStyle.pointing}.${FcModuleStyle.label}.${FcModuleStyle.simProg}`).style.top = top + "px";
  //     }
  //   }
  //   if (document.querySelector(`.${FcModuleStyle['sim-progress-activity']} .${FcModuleStyle.posuccess}`) != null && window.innerWidth < 991 && document.querySelector(`.${FcModuleStyle.simProg}`) != null) {
  //     document.querySelector(`.${FcModuleStyle.ui}.${FcModuleStyle.pointing}.${FcModuleStyle.label}.${FcModuleStyle.simProg}`).style.left = "20%";
  //   }
  // }, [simPrgPopup]);
  useEffect(() => {
    if ((simObj.status == 'COMPLETED') && (document.getElementById("showSummary") != null)) {
      document.getElementById("showSummary").focus();
    }
  }, [simObj.status]);

  useEffect(() => {
    let timer;
    if ((simObj?.status === "COMPLETED" || !isPlaying) && simObj?.currentstep !== 2) {
      // Delay screen reader announcement
      timer = setTimeout(() => {
        setAlertActive(true);

        // Force update message so SR reads it
        setSrMessage(
          `Mean Absolute Percent Error: ${simObj?.laststate?.overAllMAPE ?? 0} percent.
          Regular: ${simObj?.laststate?.fuelInformations?.REGULAR?.meanAbsolutePercentageError
            ? Math.floor(simObj.laststate.fuelInformations.REGULAR.meanAbsolutePercentageError)
            : 0} percent; 
          Midgrade: ${simObj?.laststate?.fuelInformations?.MIDGRADE?.meanAbsolutePercentageError
            ? Math.floor(simObj.laststate.fuelInformations.MIDGRADE.meanAbsolutePercentageError)
            : 0} percent; 
          Premium: ${simObj?.laststate?.fuelInformations?.PREMIUM?.meanAbsolutePercentageError
            ? Math.floor(simObj.laststate.fuelInformations.PREMIUM.meanAbsolutePercentageError)
            : 0} percent.`
        );
      }, 4500);
    } else {
      setAlertActive(false);
      setSrMessage("");
    }

    return () => clearTimeout(timer);
  }, [simObj?.status, isPlaying, simObj?.currentstep]);

  return (
    <div className={`${FcModuleStyle['sim-progress-activity']} ${fcPopup?.trackSimulation ? `show ${FcModuleStyle['show']}` : ''}`}>
      <div className={`${FcModuleStyle.pie}`} title={`${currentTime}% completed.`} style={{ '--p': (simObj.status == 'COMPLETED') ? 100 : currentTime, '--b': '10px', '--c': 'purple' }} role='progressbar'></div>
      <div className={`${FcModuleStyle._progress} ${simPrgPopup ? `show ${FcModuleStyle.show}` : ''}`}>
        <div className={`${FcModuleStyle['time-progress']}`}>
          <div className={`${FcModuleStyle['remain-time']}`}>
            {/* <img className={(toggleSimulation && simObj.status != 'COMPLETED') ? `${FcModuleStyle.spin}` : ''} src={time_elapse_icon} alt="" /> */}
            <span style={{ "text-align": "center" }}><strong>{getMonth(simObj?.currentstate?.statemonth)} {simObj?.currentstate?.stateyear} </strong><br />({simObj?.currentstate?.monthsleft} Month Remaining)</span>
            {/* Hidden plain text for screen readers */}
            <span className="sr-only" role="status" aria-live="polite">
              {`${getMonth(simObj?.currentstate?.statemonth)} ${simObj?.currentstate?.stateyear} (${simObj?.currentstate?.monthsleft} Month Remaining)`}
            </span>
          </div>
          <div className={`ui progress indicating ${FcModuleStyle.progress} ${FcModuleStyle.ui}`}>
            <div className={`${FcModuleStyle['background']}`} id="time">
              <div role="progressbar"
                aria-valuenow={progressbar.valuenow()}
                aria-valuemin={progressbar.valuemin}
                aria-valuemax={progressbar.valuemax}
                aria-valuetext={`${progressbar.valuenow()}%`}
                className={` ${FcModuleStyle['progress-fg']} ${(toggleSimulation && simObj.status != 'COMPLETED') ? `${FcModuleStyle.active}` : ''}`} style={{ "width": progressbar.valuenow() + '%' }}></div>
            </div>
          </div>
        </div>
        {
          //(toggleSimulation && simObj.status != 'COMPLETED') && <Button btnName="Pause Simulation" clickEventHandler={pauseSimulation} btnId="pauseSumButton" />
        }{
          // (!toggleSimulation && simObj.status != 'COMPLETED') && <Button disabled={(simObj.laststate?.quantityordered == 0 && simObj?.currentstep == 0) ? true : false} btnName={simObj.currentstep == 0 ? 'Start Simulation' : 'Resume Simulation'} clickEventHandler={playSimulation} btnId="playSumButton" />
        }{
          (simObj.status == 'COMPLETED') && <Button btnName="Show Summary" clickEventHandler={showSummary} btnId="showSummary" />
        }

      </div>
      <div className={`${FcModuleStyle['simmsg-container']}`}>
        {
          (simObj?.status == 'COMPLETED' || !isPlaying) && (simObj?.currentstep != 2) && <div className={`ui success message ${FcModuleStyle.ui} ${FcModuleStyle.success} ${FcModuleStyle.message} ${FcModuleStyle.simmsg}`}>
            <div role={alertActive ? "alert" : undefined} aria-live="polite">
              {simObj?.status === "COMPLETED" ? (
                <>
                  <img src={info} alt="info" />
                  <p>Simulation is completed! Please click on "Show Summary" to view report.</p>
                </>
              ) : (
                <>
                  <img src={info} alt="info" />
                  <p>Result of your decision are displayed, Please update your forecast and click Submit.</p>
                </>
              )}
            </div>

            {/* Screen-reader to read MAPE block */}
            <div className="sr-only" role="status" aria-atomic="true">
              {srMessage}
            </div>
          </div>
        }
        {
          (simObj?.status != 'COMPLETED' && simObj?.currentstep == 2) ? <div className={`ui success message ${FcModuleStyle.ui} ${FcModuleStyle.success} ${FcModuleStyle.message} ${FcModuleStyle.simmsg}`}>
          <div role='alert'>
            {
              (<><img src={info} alt="info" /><p>{`Simulation is started.`}</p></>)
            }
          </div>
        </div> : ''
        }
      </div>
    </div>
  )
}

export default SimProgress